/**
 * Toast通知服务 - 与GlobalToast组件集成
 */
export const useToast = () => {
  // 触发全局Toast事件
  const triggerToast = (message: string, type: string, duration: number = 3000) => {
    if (process.client) {
      window.dispatchEvent(new CustomEvent('show-toast', {
        detail: { message, type, duration }
      }));
    }
  };

  // 显示成功消息
  const success = (message: string, duration: number = 3000) => {
    if (process.client) {
      console.log('✅ 成功:', message);
      triggerToast(message, 'success', duration);
    }
  };

  // 显示错误消息
  const error = (message: string, duration: number = 3000) => {
    if (process.client) {
      console.error('❌ 错误:', message);
      triggerToast(message, 'error', duration);
    }
  };

  // 显示警告消息
  const warning = (message: string, duration: number = 3000) => {
    if (process.client) {
      console.warn('⚠️ 警告:', message);
      triggerToast(message, 'warning', duration);
    }
  };

  // 显示信息消息
  const info = (message: string, duration: number = 3000) => {
    if (process.client) {
      console.info('ℹ️ 信息:', message);
      triggerToast(message, 'info', duration);
    }
  };

  return {
    success,
    error,
    warning,
    info
  };
}; 